import React, { useContext, useEffect, useRef, useState } from 'react';
import { ProductDetailsPage } from '../types';

interface PropTypes {
  productDetails: ProductDetailsPage['productDetails'];
}

export interface ContextTypes {
  contentTab: number | null;
  onContentTabChange: (newIndex: number | null) => void;
}

export const ProductDetailsContext = React.createContext<ContextTypes>(
  {} as any
);

export const ProductDetailsProvider: React.FC<
  React.PropsWithChildren<PropTypes>
> = ({ children }) => {
  const [contentTab, setContentTab] = useState<null | number>(null);

  const isInit = useRef(true);

  useEffect(() => {
    if (!isInit.current) {
      setContentTab(null);
    }
    isInit.current = false;
  }, []);

  return (
    <ProductDetailsContext.Provider
      value={{
        contentTab,
        onContentTabChange: setContentTab,
      }}
    >
      {children}
    </ProductDetailsContext.Provider>
  );
};

export const useProductDetailsState = (): ContextTypes =>
  useContext(ProductDetailsContext);
export type PdpContextTypes = ContextTypes;
